import * as firebase from "firebase/app"

import googleServices from "./google-services.json"

const app = firebase.default.initializeApp(googleServices)

const firebaseInit = "Init (web)"

export default firebaseInit
